<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "Auth",
  components: {},

  data: () => ({
    //
  }),
};
</script>
